<template>
  <!-- Wallet Card Text Field -->
  <div class="mt-3">
    <dp-input
      :id="`${name}-input`"
      v-model.trim="localValue"
      :aria-placeholder="value"
      :immediate-validation="immediateValidation"
      :label="$t(title)"
      :name="name"
      :validation-rules="validationRules"
      :validation-state="validated ? 'valid' : null"
      label-class="h2 text-primary"
      class="wallet-card-text-field text-left notranslate"
      type="text"
      translate="no"
      @input="$emit('input', localValue)"
    >
      <template v-if="characterLimit" #sub-text>
        <span v-show="localValue.length <= characterLimit" class="text-dark">
          {{ characterCounter }}
        </span>
      </template>
    </dp-input>
  </div>
</template>

<script>
import DpInput from '@/components/library/Input';

export default {
  name: 'WalletCardTextField',
  components: { DpInput },
  props: {
    validated: {
      type: Boolean,
      default: false,
      required: true,
    },
    immediateValidation: {
      type: Boolean,
      default: false,
      required: false,
    },
    characterLimit: {
      type: [String, Number],
      default: 35,
      required: false,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    label: {
      type: String,
      default: '',
      required: false,
    },
    name: {
      type: String,
      default: 'text-field',
      required: false,
    },
    value: {
      type: [String, Number],
      default: '',
      required: false,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    characterLimitRule() {
      return this.characterLimit ? { max: this.characterLimit } : {};
    },
    validationRules() {
      return { before: { valid: true }, required: true, noEmojis: true, ...this.characterLimitRule };
    },
    characterCounter() {
      const counter = this.characterLimit - (this.localValue?.length ?? 0);
      return `${counter} ${counter === 1 ? 'character' : 'characters'} remaining.`;
    },
  },
};
</script>

<style lang="scss">
@import '@docupet/component-library/src/assets/styles/main';

.wallet-card-text-field .form-group .form-control {
  height: 3.5rem;
  @include media-breakpoint-up(lg) {
    height: 4rem;
    font-size: 1.5rem;
  }
}
</style>
